import List from "@/components/list";
import Bus from "./Bus.js";
import vue from "@/main";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  // function showDetail({ row }) {
  //   Bus.$emit("details", row);
  // }
  function handleUpdate({ row }) {
    Bus.$emit("ReceiveMessage", Object.assign({}, row));
  }
  //删除
  function handleDelete({ row }) {
    Bus.$emit("deleteShortVideoPublisher", row);
  }
  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      [
        "icon-edit",
        "编辑",
        () => handleUpdate(vo),
        "shortVideoPublisher:update"
      ],
      [
        "icon-delete",
        "删除",
        () => handleDelete(vo),
        "shortVideoPublisher:delete"
      ]
    ];
    // v-permission={item[2]}
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[1]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  function showDetail(vo) {
    vue.$emit("showImg", vo.row);
  }
  const Img = ({ props: { vo } }) => {
    return (
      <div onClick={() => showDetail(vo)}>
        <img src={vo.row.iconUrl} style="width:30%" />
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "发布主体名称",
      prop: "publisherName",
      minWidth: "160",
      showOverflowTooltip: true
    },
    {
      label: "发布logo",
      prop: "iconUrl",
      minWidth: "130",
      render: vo => <Img vo={vo} />
    },
    {
      label: "上线状态",
      prop: "onlineStatusName",
      minWidth: "130"
    },
    {
      label: "操作",
      fixed: "right",
      minWidth: "130",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
